import { getData } from "common/services";
import { ItemsUri } from "./constants";

export const getParsedItems = async (uid: string, token: string) =>
  await getData(`${ItemsUri(uid)}`, token);
